import Entity from '../entity'

export default class DealerContact extends Entity<number>{
    dealer_id: number;
    type_id: number;
    employee_id: number;
}


